import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EasyEnvironment } from '@easy-lib/modules/shared/models/environment';

@Injectable({
	providedIn: 'root'
})
export class StartupService {
	// hostUrl: string;
	private retryTimes = 100;
	previousSelectedUrls = [];
	authenticationType: AuthType;
	// get endpoint(): string {
	//   if (this.environment.setting.endpointApi.length === this.previousSelectedUrls.length) {
	//     this.previousSelectedUrls = [];
	//   }

	//   var selected = this.randomUrl(this.environment.setting.endpointApi);
	//   while (this.previousSelectedUrls.indexOf(selected) >= 0) {
	//     selected = this.randomUrl(this.environment.setting.endpointApi);
	//   }
	//   this.previousSelectedUrls.push(selected);
	//   return selected;
	// }
	public get appSettingUrl(): string {
		return this.environment.setting.appSettingsUrl + 'auth';
	}
	constructor(private environment: EasyEnvironment) {}

	// This is the method you want to call at bootstrap
	// Important: It should return a Promise
	public getApiEndpoints() {
		// if (this.environment.env == EnvType.DEV || this.environment.env == EnvType.PEN) {
		//   this.hostUrl = this.environment.setting.apipath[0];
		// }
		// else {
		return this.getAuthenticationType().toPromise();
		// }
	}
	private getAuthenticationType(): Observable<any> {
		this.authenticationType = AuthType.Primary;
		return of(null);
		// return this.client.get<any>(this.appSettingUrl)
		//   .pipe(
		//     map(data => data.authenticationSettings.filter(x => x.authClient == AuthClient.Orbis)),
		//     tap((data) => this.authenticationType = data[0]?.authType),
		//     catchError((error) => {
		//       this.authenticationType = AuthType.Primary
		//       return of(null)
		//     })
		//   )
	}
	// private getEndpoints(): Observable<any> {
	//   return of(new Array(this.retryTimes)).pipe(
	//     switchMap(() => (this.client.get<any>(this.endpoint)
	//       .pipe(
	//         tap(data => {
	//           this.hostUrl = this.randomUrl(data);
	//         })
	//       ))),
	//     retryWhen(error => error.pipe(delay(1000), take(this.retryTimes)))
	//   );

	// }

	private randomUrl(urls: string[]) {
		const n = urls.length;
		if (n == 0) {
			return ''; //no default
		} else if (n == 1) {
			return urls[0];
		} else {
			const rnd = Math.floor(Math.random() * n);
			return urls[rnd];
		}
	}
}
export interface authenticationSettings {
	authenticationSettings: AuthenticationSettingItem[];
}
export interface AuthenticationSettingItem {
	authClient: AuthClient;
	authType: AuthType;
}
export enum AuthType {
	Primary = 0,
	Secondary = 1
}
export enum AuthClient {
	Easy = 0,
	Orbis = 1
}
